import React from "react";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography,
  FormControlLabel
} from "@mui/material";
import { EnhancedTableToolbar } from "./EnhancedTableToolbar";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { withStyles } from "@mui/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import spinner from "../assign-prescriptions/images/spinner.gif";
import moment from "moment";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import Selector from '../select';
import Switch from '@mui/material/Switch';
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  foldFiltersToSearchText,
  getActionsColumn,
  actionMenuItem,
  openAgGridContextMenu,
} from '../grid/iLocalAGGrid';
const TaskTypeEnum = require('./taskTypeEnum').default;

const { log } = console;

const BootstrapDialogTitle = (props) => {
  const { children, onDialogClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onDialogClose && (
        <IconButton
          aria-label="close"
          onClick={onDialogClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onDialogClose: PropTypes.func.isRequired,
};

const HTMLTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#f5f5f9",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "0.8125rem",
    border: "1px solid #dadde9",
    borderRadius: "5px",
  },
}));

const useStyles = (theme) => ({
  primaryButton: {
    background: "#6cca98",
    color: "#fff",
    "&:hover": {
      background: "#6cca98",
      color: "#fff",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.38)",
      cursor: "not-allowed",
      background: "#E4E5E8",
    },
  },
  deleteButton: {
    "&:hover": {
      background: "#6cca98",
      color: "#fff",
    },
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.38)",
      cursor: "not-allowed",
      background: "#E4E5E8",
    },
  },
  spinner: {
    position: "absolute",
    background: "rgba(255,255,255,.4)",
    width: "100%",
    height: "100%",
    zIndex: "9999",
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: "calc(50% - 30.5px)",
    left: "calc(50% - 65px)",
    position: "absolute",
    width: "130px",
    userSelect: "none",
  },
});

let filterObj = {
  searchtext: "",
  pageNo: 0,
  pageSize: 10,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "task_manager",
  statusList: [],
  priorityList: [],
  actionList: [],
  searchObject: null,
};

const TaskSortObj = {
  task_name: { tableName: "task_manager", sortColumn: "task_name" },
  taskType: { tableName: "task_manager", sortColumn: "task_type_id" },
  status: { tableName: "task_manager", sortColumn: "status" },
  priority: { tableName: "task_manager", sortColumn: "priority" },
  reminder_date: { tableName: "task_manager", sortColumn: "reminder_date" },
  due_date: { tableName: "task_manager", sortColumn: "due_date" },
  patientName: { tableName: "customers", sortColumn: "name" },
  userName: { tableName: "users", sortColumn: "name" },
  selected_emails: { tableName: "task_manager", sortColumn: "selected_emails" },
  is_enabled: { tableName: "task_manager", sortColumn: "is_enabled" },
};

const PRIORITY = ["Low", "Medium", "High", "Critical"];
const STATUS = ["Open", "InProgress", "Complete"];
// const ACTION = ["Open", "Complete", "Delete", "Close"];

class TaskManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openTaskManagerDialog: false,
      taskTitle: "",
      action: "Open",
      reminderDate: new Date(),
      dueDate: new Date(),
      userDataList: [],
      selectedUserID: "",
      selectedUserName: "",
      taskTypeList: [],
      selectedTaskTypeID: "",
      selectedTaskName: "",
      status: "Open",
      priority: "Low",
      patientDataList: [],
      selectedPatientID: "",
      selectedPatientName: "",
      loadingSpinner: false,
      operation: "Add",
      taskDetails: "",
      orderCode: "",
      totalRecords: 0,
      data: [],
      isDataEmpty: false,
      selectedData: [],
      sortID: null,
      anchorEl: null,
      selectedRowID: null,
      openDeleteDialog: false,
      confirmedDeleteList: [],
      filterStatusList: [],
      filterActionList: [],
      filterPriorityList: [],
      openUserAutoComplete: false,
      openPatientAutoComplete: false,
      isTaskTitleRequired: false,
      isTaskDetailsRequired: false,
      isUserRequired: false,
      isPatientRequired: false,
      selectedUser: "",
      selectedUserInputValue: "",
      selectedPatient: "",
      selectedPatientInputValue: "",
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      currentSelection: null,
      initialValue: [],
      accountValues: [],
      parent_account_id: null,
      selectedEmails: null,
      isEanbled: true,
      isTaskEmailRequired: false
    };
  }

  componentDidMount = async () => {
    this.callInitialAPIs();
  };

  emitNotificationEvent = (UserID) => {
    window &&
      window.notificationSocket.emit("UserSendingNotificationEvent", {
        UserID,
        Message: "User sending notification events from connect!!",
      });
  };

  gettingUserLists = (queryParam) => {
    try {
      fetch(
        process.env.REACT_APP_BASEURL +
        "taskmanager/UsersList?searchText=" +
        queryParam,
        {
          method: "GET",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then(async (response) => {
          if (
            response &&
            Array.isArray(response["results"]) &&
            response["results"].length > 0
          ) {
            const userDataList = response["results"].map((user) => {
              return { id: user.id, value: user.name };
            });
            this.setState({
              userDataList,
              selectedUserIDs: userDataList,
              selectedUserID: response["results"][0]["id"],
              selectedUserName: response["results"][0]["name"],
            });
          } else this.setState({ userDataList: [], selectedUserID: "" });
        });
    } catch (ErrorException) {
      log(
        "(TaskManager): Error ocurred while getting the users details!",
        ErrorException
      );
    }
  };

  gettingTaskManagerTypesList = () => {
    try {
      fetch(process.env.REACT_APP_BASEURL + "taskmanager/TaskType", {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (
            response &&
            Array.isArray(response["results"]) &&
            response["results"].length > 0
          ) {
            this.setState({
              taskTypeList: response["results"],
              selectedTaskTypeID: response["results"][0]["id"],
              selectedTaskName: response["results"][0]["name"],
            });
          } else this.setState({ taskTypeList: [], selectedTaskTypeID: "" });
        });
    } catch (ErrorException) {
      log(
        "(TaskManager): Error ocurred while getting the task types details!",
        ErrorException
      );
    }
  };

  gettingPatientList = (queryParam) => {
    try {
      fetch(
        process.env.REACT_APP_BASEURL +
        "taskmanager/PatientList?searchText=" +
        queryParam,
        {
          method: "GET",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
        }
      )
        .then((response) => response.json())
        .then(async (response) => {
          if (
            response &&
            Array.isArray(response["results"]) &&
            response["results"].length > 0
          ) {
            const patientDataList = response["results"].map((patient) => {
              return { id: patient.id, name: patient.name };
            });
            this.setState({
              patientDataList,
              selectedPatientID: response["results"][0]["id"],
              selectedPatientName: response["results"][0]["name"],
            });
          } else this.setState({ patientDataList: [], selectedPatientID: "" });
        });
    } catch (ErrorException) {
      log(
        "(TaskManager): Error ocurred while getting the patients details!",
        ErrorException
      );
    }
  };

  gettingTaskManagerDetailsFromDB = async () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
  };

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      filterBody: filterObj,
      applyFilterModel: (body, filterModel) => {
        const model = filterModel || {};

        // Status / Priority set-filters → API list filters
        const statusValues =
          model.status && Array.isArray(model.status.values)
            ? model.status.values.filter(Boolean)
            : [];
        const priorityValues =
          model.priority && Array.isArray(model.priority.values)
            ? model.priority.values.filter(Boolean)
            : [];

        body.statusList = statusValues;
        body.priorityList = priorityValues;
        body.actionList = [];

        // Enabled set-filter → searchtext Yes/No (API ilike on text fields is weak;
        // map to exact boolean via dedicated body flag if needed later)
        const enabledValues =
          model.is_enabled && Array.isArray(model.is_enabled.values)
            ? model.is_enabled.values.filter(Boolean)
            : [];
        if (enabledValues.length === 1) {
          body.is_enabled =
            enabledValues[0] === "Yes" || enabledValues[0] === true;
        } else {
          delete body.is_enabled;
        }

        body.searchtext = foldFiltersToSearchText(model, {
          excludeColIds: ["status", "priority", "actions", "is_enabled"],
        });
        body.searchObject =
          Object.keys(model).length > 0 ? model : null;
      },
      sortMap: TaskSortObj,
      pageZeroBased: true,
      getPageSize: () => filterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + "taskmanager/details", {
          method: "POST",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            // API: { results: { results: [...], total: N } }
            const nested = response && response.results;
            return {
              results:
                nested && Array.isArray(nested.results) ? nested.results : [],
              total: (nested && nested.total) || 0,
            };
          }),
      onSuccess: (results, total) => {
        this.setState({
          data: results || [],
          totalRecords: total || 0,
          loadingSpinner: false,
          isDataEmpty: !results || results.length === 0,
          selectedData: [],
        });
      },
      onError: () => this.setState({ loadingSpinner: false }),
    });
    if (typeof params.api.setServerSideDatasource === "function") {
      params.api.setServerSideDatasource(datasource);
    }
  };

  onRowSelected = (params) => {
    if (!params || !params.api) return;
    const selectedNodes = params.api.getSelectedNodes() || [];
    this.setState({
      selectedData: selectedNodes
        .map((n) => n.data && n.data.id)
        .filter(Boolean),
    });
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && filterObj.pageSize !== newPageSize) {
      filterObj.pageSize = newPageSize;
    }
  };

  openRowActionsMenu = (event, params, menuHelpers) => {
    const row = params && params.data;
    if (row && row.id != null) {
      // Intentional: avoid re-render before opening the actions menu.
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state.selectedRowID = row.id;
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state._contextRow = row;
    }
    const items = this.getContextMenuItems({
      ...params,
      column: params.column,
      node: params.node,
      value: params.value,
    });
    if (menuHelpers && typeof menuHelpers.openMenu === "function") {
      menuHelpers.openMenu(items);
      return;
    }
    openAgGridContextMenu(
      params,
      (menuHelpers && menuHelpers.positionEvent) || event
    );
  };

  getContextMenuItems = (params) => {
    const colId =
      params &&
      params.column &&
      (params.column.getColId
        ? params.column.getColId()
        : params.column.colId);
    if (colId !== "actions") return [];
    if (!(params.node && params.node.data)) return [];
    const { t } = this.props;
    return [
      actionMenuItem({
        name: t("Task.ViewAction"),
        icon: "view",
        action: () => this.handleOpenView(),
      }),
      actionMenuItem({
        name: t("Task.EditAction"),
        icon: "edit",
        action: () => this.handleOpenEdit(),
      }),
      actionMenuItem({
        name: t("Task.DeleteAction"),
        icon: "delete",
        action: () => this.handleOpenDeleteDialog(true),
      }),
    ];
  };

  getColumnDefs = () => {
    const { t } = this.props;
    return [
      {
        field: "task_name",
        headerName: t("Task.TaskTitle"),
        minWidth: 140,
        cellRenderer: (params) => {
          const value = params.data && params.data.task_name;
          if (!this.handleValidateFields(value)) return null;
          if (String(value).trim().length > 10) {
            return (
              <HTMLTooltip
                placement="right"
                title={
                  <React.Fragment>
                    <Typography color="inherit">{value}</Typography>
                  </React.Fragment>
                }
              >
                <Typography color="inherit" sx={{ fontSize: "0.8125rem" }}>
                  {String(value).slice(0, 3) + "..."}
                </Typography>
              </HTMLTooltip>
            );
          }
          return value;
        },
      },
      {
        field: "taskType",
        headerName: t("Task.TaskType"),
        minWidth: 120,
      },
      {
        field: "status",
        headerName: t("Task.Status"),
        minWidth: 130,
        filter: "agSetColumnFilter",
        filterParams: {
          values: STATUS,
          defaultToNothingSelected: true,
          buttons: ["clear", "apply"],
          closeOnApply: true,
        },
        menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
        cellRenderer: (params) => {
          const value = params.data && params.data.status;
          if (!this.handleValidateFields(value)) return null;
          return (
            <Chip
              label={value}
              variant="outlined"
              size="medium"
              sx={{
                "&.MuiChip-root": {
                  color: this.renderStatusColor(value),
                  border: `2px solid ${this.renderStatusColor(value)}`,
                },
              }}
            />
          );
        },
      },
      {
        field: "priority",
        headerName: t("Task.Priority"),
        minWidth: 130,
        filter: "agSetColumnFilter",
        filterParams: {
          values: PRIORITY,
          defaultToNothingSelected: true,
          buttons: ["clear", "apply"],
          closeOnApply: true,
        },
        menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
        cellRenderer: (params) => {
          const value = params.data && params.data.priority;
          if (!this.handleValidateFields(value)) return null;
          return (
            <Chip
              label={value}
              variant="outlined"
              size="medium"
              sx={{
                "&.MuiChip-root": {
                  color: this.renderPriorityColor(value),
                  border: `2px solid ${this.renderPriorityColor(value)}`,
                },
              }}
            />
          );
        },
      },
      {
        field: "reminder_date",
        headerName: t("Task.ReminderDate"),
        minWidth: 150,
        valueFormatter: (params) =>
          this.handleValidateFields(params.value)
            ? this.convertToTimezone(params.value)
            : "",
      },
      {
        field: "due_date",
        headerName: t("Task.DueDate"),
        minWidth: 150,
        valueFormatter: (params) =>
          this.handleValidateFields(params.value)
            ? this.convertToTimezone(params.value)
            : "",
      },
      {
        field: "patientName",
        headerName: t("Task.Patient"),
        minWidth: 120,
      },
      {
        field: "userName",
        headerName: t("Task.User"),
        minWidth: 120,
      },
      {
        field: "selected_emails",
        headerName: t("Patient.Email"),
        minWidth: 200,
      },
      {
        field: "is_enabled",
        headerName: t("Patient.Enabled"),
        minWidth: 110,
        filter: "agSetColumnFilter",
        filterParams: {
          values: ["Yes", "No"],
          defaultToNothingSelected: true,
          buttons: ["clear", "apply"],
          closeOnApply: true,
        },
        menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
        valueGetter: (params) =>
          params.data && [true, "true"].includes(params.data.is_enabled)
            ? "Yes"
            : "No",
      },
      getActionsColumn({
        headerName: t("Task.Actions") || "Actions",
        onActionsClick: (event, params, menuHelpers) =>
          this.openRowActionsMenu(event, params, menuHelpers),
      }),
    ];
  };

  handleOpenTaskManagerDialog = () => {
    this.setState({
      openTaskManagerDialog: true,
      operation: "Add",
      selectedRowID: null,
      taskTitle: "",
      action: "Open",
      reminderDate: new Date(),
      dueDate: new Date(),
      status: "Open",
      priority: "Low",
      taskDetails: "",
      orderCode: "",
      filterStatusList: [],
      filterActionList: [],
      filterPriorityList: [],
      isTaskTitleRequired: false,
      isTaskDetailsRequired: false,
      isUserRequired: false,
      isPatientRequired: false,
      selectedUser: { id: "", name: "" },
      selectedPatient: { id: "", name: "" },
      selectedUserInputValue: "",
      selectedPatientInputValue: "",
      selectedUserID: "",
      selectedPatientID: "",
    });
    this.setUserAutoCompleteAction(false);
    this.handleChangeUsers(null, null, "clear");
    this.handleChangePatients(null, null, "clear");
    this.gettingUserLists();
  };

  handleCloseTaskManagerDialog = () => {
    this.setState({ openTaskManagerDialog: false });
    this.setUserAutoCompleteAction(false);
    this.handleChangeUsers(null, null, "clear");
    this.handleChangePatients(null, null, "clear");
  };

  handleChangeTaskType = (event) => {
    const { value } = event.target;
    let selectedTaskName = "";
    let findTask = this.state.taskTypeList.find(({ id }) => id === value);
    if (findTask) {
      selectedTaskName = findTask["name"];
    }
    this.setState({
      selectedTaskTypeID: event.target.value,
      selectedTaskName,
    });
  };

  handleChangeUsers = (event, value, reason) => {
    if (reason === "selectOption") {
      const { id, name } = value;
      this.setState({
        selectedUserID: id,
        selectedUserName: name,
        selectedUser: value,
      });
    } else {
      this.setState({
        userDataList: [],
        // selectedUser: { id: "", name: "" },
        // selectedUserID: "",
        // selectedUserName: "",
      });
      this.setUserAutoCompleteAction(false);
    }
  };

  handleChangePatients = (event, value, reason) => {
    if (reason === "selectOption") {
      const { id, name } = value;
      this.setState({
        selectedPatientID: id,
        selectedPatientName: name,
        selectedPatient: value,
      });
    } else {
      this.setState({
        patientDataList: [],
        // selectedPatient: { id: "", name: "" },
        // selectedPatientID: "",
        // selectedPatientName: "",
      });
      this.setPatientAutoCompleteAction(false);
    }
  };

  renderLoaderIndicator = () => {
    const { classes } = this.props;
    return (
      this.state.loadingSpinner && (
        <Box component="div" className={classes["spinner"]}>
          <Box
            component="img"
            className={classes["spinnerImage"]}
            src={spinner}
            alt="loading"
          />
        </Box>
      )
    );
  };

  handleCloseContextMenuClick = (event) => {
    if (event && event.preventDefault) event.preventDefault();
    this.setState({ anchorEl: null, selectedRowID: null });
  };

  handleStates = () => {
    let selectedData =
      this.state.data.find(({ id }) => id === this.state["selectedRowID"]) ||
      this.state._contextRow;
    if (!selectedData) return;
    this.setState({
      taskTitle: selectedData["task_name"],
      action: selectedData["action"],
      reminderDate: selectedData["reminder_date"],
      dueDate: selectedData["due_date"],
      selectedTaskTypeID: selectedData["task_type_id"],
      selectedTaskName: selectedData["taskType"],
      selectedUserID: selectedData["user_id"],
      selectedUserName: selectedData["userName"],
      status: selectedData["status"],
      priority: selectedData["priority"],
      taskDetails: selectedData["task_details"],
      selectedPatientID: selectedData["patient_id"],
      selectedPatientName: selectedData["patientName"],
      orderCode: selectedData["order_code"],
      selectedEmails: selectedData["selected_emails"],
      isEanbled: selectedData["is_enabled"],
      selectedUser: {
        id: selectedData["user_id"],
        name: selectedData["userName"],
      },
      selectedPatient: {
        id: selectedData["patient_id"],
        name: selectedData["patientName"],
      },
    });
  };

  handleOpenView = (event) => {
    this.setState({
      operation: "View",
      openTaskManagerDialog: true,
      isTaskTitleRequired: false,
      isTaskDetailsRequired: false,
      isUserRequired: false,
      isPatientRequired: false,
    });
    this.handleStates();
    this.handleCloseContextMenuClick(event);
  };

  handleOpenEdit = (event) => {
    const selectedObject =
      this.state["data"].find(({ id }) => id === this.state["selectedRowID"]) ||
      this.state._contextRow;
    if (!selectedObject) return;
    this.setState({
      operation: "Edit",
      openTaskManagerDialog: true,
      selectedRow: selectedObject,
      isTaskTitleRequired: false,
      isTaskDetailsRequired: false,
      isUserRequired: false,
      isPatientRequired: false,
    });
    this.handleStates();
    this.gettingUserLists(selectedObject.userName);
    this.handleCloseContextMenuClick(event);
  };

  handleOpenDeleteDialog = (fromContextMenu) => {
    if (fromContextMenu && this.state["selectedRowID"]) {
      let selectedRow = this.state.data.filter(
        ({ id }) => id === this.state["selectedRowID"]
      );
      if (
        (!selectedRow || selectedRow.length === 0) &&
        this.state._contextRow
      ) {
        selectedRow = [this.state._contextRow];
      }

      this.setState({
        openDeleteDialog: true,
        confirmedDeleteList: selectedRow,
      });
    } else {
      // Toolbar bulk delete — ignore any leftover kebab selectedRowID
      // eslint-disable-next-line react/no-direct-mutation-state
      this.state.selectedRowID = null;
      let selectedRows = this.state.data.filter(
        ({ id }) => this.state["selectedData"].indexOf(id) > -1
      );
      this.setState({
        openDeleteDialog: true,
        confirmedDeleteList: selectedRows,
      });
    }
  };

  handleCloseDeleteDialog = (event) => {
    if (this.state["selectedRowID"]) {
      this.setState({
        openDeleteDialog: false,
        selectedRowID: null,
        confirmedDeleteList: null,
        selectedData: [],
      });
      this.handleCloseContextMenuClick(event);
    } else
      this.setState({
        openDeleteDialog: false,
        selectedRowID: null,
        confirmedDeleteList: null,
        selectedData: [],
      });
  };

  handleConfirmDelete = (event) => {
    if (this.state["selectedRowID"]) {
      this.handleConfirmDeleteTask(event, "Single");
    } else this.handleConfirmDeleteTask(event, "Multiple");
    this.setState({ openDeleteDialog: false });
  };

  handleConfirmDeleteTask = (event, ope) => {
    this.setState({ loadingSpinner: true });
    let URL =
      ope === "Single"
        ? `taskmanager/${this.state["selectedRowID"]}`
        : "taskmanager/" + this.state["selectedData"].join(",");
    fetch(process.env.REACT_APP_BASEURL + URL, {
      method: "DELETE",
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then(async (result) => {
        if (result) {
          this.setState({
            selectedData: [],
            selectedRowID: null,
            loadingSpinner: false,
          });
          this.handleCloseContextMenuClick(event);
          await this.gettingTaskManagerDetailsFromDB();
          this.emitNotificationEvent(this.state.selectedUserID);
        }
      })
      .catch((error) => {
        this.setState({
          selectedData: [],
          selectedRowID: null,
          loadingSpinner: false,
        });
        log(
          "Error Ocurred while deleting the user automation details",
          JSON.stringify(error["message"])
        );
      });
  };

  prepareTaskConfig = () => {
    let config = {
      taskTitle: String,
      action: String,
      reminderDate: Date,
      dueDate: Date,
      taskTypeID: String,
      userID: String,
      parentAccountID: String,
      status: String,
      priority: String,
      taskDetails: String,
      patientID: String,
      orderCode: String,
    };
    config["taskTitle"] = this.state.taskTitle;
    config["action"] = this.state.action;
    config["reminderDate"] = this.state.reminderDate;
    config["dueDate"] = this.state.dueDate;
    config["taskTypeID"] = this.state.selectedTaskTypeID;
    config["userID"] = this.state.selectedUserID;
    config["parentAccountID"] = sessionStorage.getItem("parentAccountId");
    config["status"] = this.state.status;
    config["priority"] = this.state.priority;
    config["taskDetails"] = this.state.taskDetails;
    config["patientID"] = this.state.selectedPatientID;
    config["orderCode"] = this.state.orderCode;
    return config;
  };

  handleSubmit = (event) => {
    const { selectedTaskTypeID, selectedEmails } = this.state;
    try {
      event && event.preventDefault();
      if(selectedTaskTypeID !== TaskTypeEnum.MonitorLiveAgents) {
        let validate = {
          isTaskTitleRequired: this.prepareTaskConfig().taskTitle,
          isTaskDetailsRequired: this.prepareTaskConfig().taskDetails,
          isUserRequired: this.prepareTaskConfig().userID,
          isPatientRequired: this.prepareTaskConfig().patientID,
        };
        validate = Object.entries(validate)
          .filter(([key, value]) => ["", null, undefined].includes(value))
          .reduce((other, [key, node]) => ({ ...other, [key]: node }), {});
        if (Object.keys(validate).length) {
          if (validate.isTaskTitleRequired === "")
            this.setState({ isTaskTitleRequired: true });
          else this.setState({ isTaskTitleRequired: false });
          if (validate.isTaskDetailsRequired === "")
            this.setState({ isTaskDetailsRequired: true });
          else this.setState({ isTaskDetailsRequired: false });
          if (validate.isUserRequired === "")
            this.setState({ isUserRequired: true });
          else this.setState({ isUserRequired: false });
          if (validate.isPatientRequired === "")
            this.setState({ isPatientRequired: true });
          else this.setState({ isPatientRequired: false });
          return true;
        }
  
        this.setState({ loadingSpinner: true });
        fetch(process.env.REACT_APP_BASEURL + "taskmanager", {
          method: "POST",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                .jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.prepareTaskConfig()),
        })
          .then((response) => response.json())
          .then((response) => {
            this.setState({
              loadingSpinner: false,
              openTaskManagerDialog: false,
            });
          });
        toast.success(this.props.t('Toast.Success.TaskCreated'));
        this.gettingTaskManagerDetailsFromDB();
        this.emitNotificationEvent(this.state.selectedUserID);        
      } else {
        if([undefined, 'undefined', null, 'null', ''].includes(selectedEmails)) {
          this.setState({ isTaskEmailRequired: true });
        } else {
          const { parent_account_id, selectedTaskTypeID, selectedEmails, isEanbled } = this.state;
          this.setState({ loadingSpinner: true });
          let body = {
            parentAccountID: parent_account_id,
            taskTypeID: selectedTaskTypeID,
            selected_emails: selectedEmails,
            isEanbled: isEanbled,
            status: 'Open'
          }
          fetch(process.env.REACT_APP_BASEURL + "taskmanager", {
            method: "POST",
            withCredentials: true,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                  .jwtToken,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((response) => {
              this.setState({
                loadingSpinner: false,
                openTaskManagerDialog: false,
              });
              toast.success(this.props.t('Toast.Success.TaskCreated'));
              this.gettingTaskManagerDetailsFromDB();
              this.setState({ selectedRow: {} });
              // setTimeout(async () => {
              //   toast.success(this.props.t('Toast.Success.TaskCreated'));
              //   await this.callInitialAPIs()
              //   this.clearFields();
              // }, 200)
            });
        }
      }
    } catch (SubmitException) {
      this.setState({
        loadingSpinner: false,
        openTaskManagerDialog: false,
      });
      log(
        "(TaskManager): Error ocurred while Submitting the task details!",
        SubmitException
      );
      toast.error(SubmitException);
    }
  };

  handleUpdate = (event) => {
    try {
      const { selectedTaskTypeID, selectedEmails } = this.state;
      if(selectedTaskTypeID !== TaskTypeEnum.MonitorLiveAgents) {
        event && event.preventDefault();
        let validate = {
          isTaskTitleRequired: this.prepareTaskConfig().taskTitle,
          isTaskDetailsRequired: this.prepareTaskConfig().taskDetails,
          isUserRequired: this.prepareTaskConfig().userID,
          isPatientRequired: this.prepareTaskConfig().patientID,
        };
        validate = Object.entries(validate)
          .filter(([key, value]) => ["", null, undefined].includes(value))
          .reduce((other, [key, node]) => ({ ...other, [key]: node }), {});
        if (Object.keys(validate).length) {
          if (validate.isTaskTitleRequired === "")
            this.setState({ isTaskTitleRequired: true });
          else this.setState({ isTaskTitleRequired: false });
          if (validate.isTaskDetailsRequired === "")
            this.setState({ isTaskDetailsRequired: true });
          else this.setState({ isTaskDetailsRequired: false });
          if (validate.isUserRequired === "")
            this.setState({ isUserRequired: true });
          else this.setState({ isUserRequired: false });
          if (validate.isPatientRequired === "")
            this.setState({ isPatientRequired: true });
          else this.setState({ isPatientRequired: false });
          return true;
        }
        this.setState({ loadingSpinner: true });
        let config = this.prepareTaskConfig();
        config["id"] = this.state["selectedRow"]["id"];
        fetch(process.env.REACT_APP_BASEURL + "taskmanager", {
          method: "PUT",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                .jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(config),
        })
          .then((response) => response.json())
          .then((response) => {
            this.setState({
              loadingSpinner: false,
              openTaskManagerDialog: false,
            });
            toast.success(this.props.t('Toast.Success.TaskUpdated'));
            this.gettingTaskManagerDetailsFromDB();
            this.setState({ selectedRow: {} });
            this.emitNotificationEvent(this.state.selectedUserID);
          });
      } else {
        if([undefined, 'undefined', null, 'null', ''].includes(selectedEmails)) {
          this.setState({ isTaskEmailRequired: true });
        } else {
          const { parent_account_id, selectedTaskTypeID, selectedEmails, isEanbled } = this.state;
          this.setState({ loadingSpinner: true });
          let body = {
            id: this.state["selectedRow"]["id"],
            parentAccountID: parent_account_id,
            taskTypeID: selectedTaskTypeID,
            selected_emails: selectedEmails,
            isEanbled: isEanbled,
            status: 'Open'
          }
          fetch(process.env.REACT_APP_BASEURL + "taskmanager", {
            method: "PUT",
            withCredentials: true,
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
                  .jwtToken,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then((response) => {
              this.setState({
                loadingSpinner: false,
                openTaskManagerDialog: false,
              });
              this.gettingTaskManagerDetailsFromDB();
              this.setState({ selectedRow: {} });
              toast.success(this.props.t('Toast.Success.TaskUpdated'));
              // setTimeout(async () => {
              //   toast.success(this.props.t('Toast.Success.TaskUpdated'));
              //   await this.callInitialAPIs();
              //   this.clearFields();
              // }, 200);
            });
        }
      }
    } catch (SubmitException) {
      this.setState({
        loadingSpinner: false,
        openTaskManagerDialog: false,
      });
      log(
        "(TaskManager): Error ocurred while Updating the task details!",
        SubmitException
      );
    }
  };

  renderStatusColor = (value) => {
    if (value === "Open") {
      return "#6554C1";
    }
    if (value === "InProgress") {
      return "#FFAB00";
    }
    if (value === "Complete") {
      return "#36B37E";
    }
  };

  renderPriorityColor = (value) => {
    if (value === "Low") {
      return "#0065FF";
    }
    if (value === "Medium") {
      return "#FFAB00";
    }
    if (["High", "Critical"].includes(value)) {
      return "#FF5630";
    }
  };

  renderActionColor = (value) => {
    if (value === "Open") {
      return "#6554C1";
    }
    if (value === "Complete") {
      return "#36B37E";
    }
    if (value === "Delete") {
      return "#FF5959";
    }
    if (value === "Close") {
      return "#FF5630";
    }
  };

  handleValidateFields = (value) => {
    if (!["", null, "null", undefined, "undefined"].includes(value)) {
      return value;
    }
    return null;
  };

  convertToTimezone = (date) => {
    return moment(date)
      .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
      .format("MM/DD/YYYY HH:mm");
  };

  setUserAutoCompleteAction = (value) => {
    this.setState({ openUserAutoComplete: value });
  };

  setPatientAutoCompleteAction = (value) => {
    this.setState({ openPatientAutoComplete: value });
  };

  onUserChange = (queryParam) => {
    if (queryParam.length > 3) {
      this.gettingUserLists(queryParam);
    }
  };

  onPatientChange = (queryParam) => {
    if (queryParam.length > 3) {
      this.gettingPatientList(queryParam);
    }
  };

  // getTextBoxInputValue = (input) => {
  //   return input.map((itm) => itm.label).join(";");
  // };

  handleSelectionChange = (result) => {
    const valueToSave = result.map((itm) => itm.label).join(";");
    this.setState({ currentSelection: valueToSave });
  };

  fetchAccounts = () => {
    fetch(process.env.REACT_APP_BASEURL + 'accounts', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accounts) => {
        const accountValues = accounts.map((account) => {
          return { value: account.id, label: account.name };
        });
        this.setState({
          accountValues,
          parent_account_id: accountValues[0].value,
        });
      });
  }

  handleSwitchChangeIsEnableTask = (event) => {
    this.setState({ isEanbled: event.target.checked });
  };

  clearFields = () => {
    this.setState = ({
      openTaskManagerDialog: false,
      taskTitle: "",
      action: "Open",
      reminderDate: new Date(),
      dueDate: new Date(),
      userDataList: [],
      selectedUserID: "",
      selectedUserName: "",
      taskTypeList: [],
      selectedTaskTypeID: "",
      selectedTaskName: "",
      status: "Open",
      priority: "Low",
      patientDataList: [],
      selectedPatientID: "",
      selectedPatientName: "",
      loadingSpinner: false,
      operation: "Add",
      taskDetails: "",
      orderCode: "",
      totalRecords: 0,
      data: [],
      isDataEmpty: false,
      selectedData: [],
      sortID: null,
      anchorEl: null,
      selectedRowID: null,
      openDeleteDialog: false,
      confirmedDeleteList: [],
      filterStatusList: [],
      filterActionList: [],
      filterPriorityList: [],
      openUserAutoComplete: false,
      openPatientAutoComplete: false,
      isTaskTitleRequired: false,
      isTaskDetailsRequired: false,
      isUserRequired: false,
      isPatientRequired: false,
      selectedUser: "",
      selectedUserInputValue: "",
      selectedPatient: "",
      selectedPatientInputValue: "",
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      currentSelection: null,
      initialValue: [],
      accountValues: [],
      parent_account_id: null,
      selectedEmails: null,
      isEanbled: true,
      isTaskEmailRequired: false
    });
  }

  callInitialAPIs = async () => {
    this.gettingTaskManagerTypesList();
    this.fetchAccounts();
  }

  render() {
    const {
      openTaskManagerDialog,
      taskTitle,
      reminderDate,
      dueDate,
      userDataList,
      taskTypeList,
      selectedTaskTypeID,
      status,
      priority,
      patientDataList,
      operation,
      orderCode,
      taskDetails,
      selectedData,
      openDeleteDialog,
      confirmedDeleteList,
      isTaskTitleRequired,
      isTaskDetailsRequired,
      isUserRequired,
      isPatientRequired,
      openUserAutoComplete,
      openPatientAutoComplete,
      selectedUser,
      selectedUserInputValue,
      selectedPatient,
      selectedPatientInputValue,
      locale,
      selectedEmails,
      isTaskEmailRequired
    } = this.state;
    const { classes, t } = this.props;
    const loading = openUserAutoComplete && userDataList.length === 0;
    const loadingPatient =
      openPatientAutoComplete && patientDataList.length === 0;
    const readOnly = operation === "View";

    return (
      <Box component="div">
        {this.renderLoaderIndicator()}
        <Box component="div" sx={{ width: "100%" }}>
          <Dialog
            maxWidth={"md"}
            fullWidth={true}
            open={openTaskManagerDialog || false}
            onClose={this.handleCloseTaskManagerDialog}
            aria-labelledby="form-dialog-title"
            PaperProps={{
              sx: { minWidth: "500px" },
            }}
          >
            {this.renderLoaderIndicator()}
            <BootstrapDialogTitle
              id="customized-dialog-title"
              onDialogClose={this.handleCloseTaskManagerDialog}
            >
              {operation} {t("Task.Task")}
            </BootstrapDialogTitle>
            <DialogContent dividers>
              {selectedTaskTypeID !== TaskTypeEnum.MonitorLiveAgents ? (<Grid container>
                <Grid item xs={12}>
                  <FormControl variant="standard" fullWidth>
                    <TextField
                      id="standard-basic"
                      label={t("Task.EnterYourTask")}
                      variant="standard"
                      value={taskTitle}
                      onChange={(event) =>
                        this.setState({
                          taskTitle: event.target.value,
                          isTaskTitleRequired: false,
                        })
                      }
                      disabled={Boolean(readOnly)}
                      error={isTaskTitleRequired}
                      helperText={
                        isTaskTitleRequired && t("Task.Validate.EnterTaskTitle")
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>) : (
                <Selector
                  id='parent_account_id'
                  label={t('Accounts.Account')}
                  values={this.state.accountValues}
                  selected={this.state.parent_account_id}
                  onBlur={this.handleChange}
                  readOnly={readOnly}
                  disableWhenViewSelect={readOnly}
                />
              )}
              {selectedTaskTypeID !== TaskTypeEnum.MonitorLiveAgents ? (
              <Grid container sx={{ mt: "10px" }}>
                <Grid item xs={6} sx={{ p: "0 10px 0 0" }}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                      <DesktopDatePicker
                        label={t("Task.ReminderDateLabel")}
                        value={reminderDate}
                        onChange={(date) =>
                          this.setState({ reminderDate: date })
                        }
                        disabled={Boolean(readOnly)}
                        // minDate={new Date()}
                        renderInput={(params) => (
                          <TextField
                            label={t("Task.ReminderDateLabel")}
                            variant="standard"
                            fullWidth
                            {...params}
                            sx={{
                              ".MuiInput-input": {
                                color: "#1197B2",
                                fontWeight: "500",
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={6} sx={{ p: "0 0 0 10px" }}>
                  <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                      <DesktopDatePicker
                        label={t("Task.DueDateLabel")}
                        value={dueDate}
                        onChange={(date) => this.setState({ dueDate: date })}
                        disabled={Boolean(readOnly)}
                        // minDate={new Date()}
                        renderInput={(params) => (
                          <TextField
                            label={t("Task.DueDateLabel")}
                            variant="standard"
                            fullWidth
                            {...params}
                            sx={{
                              ".MuiInput-input": {
                                color: "#1197B2",
                                fontWeight: "500",
                              },
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
              </Grid>) : null}
              <Grid container spacing={2} sx={{ mt: "0px" }}>
                <Grid item xs={6}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel id="demo-simple-select-standard-label">
                      {t("Task.TypeLabel")}
                    </InputLabel>
                    <Select
                      labelId="action-simple-select-standard-label"
                      id="action-simple-select-standard"
                      value={selectedTaskTypeID}
                      onChange={(event) => this.handleChangeTaskType(event)}
                      label="Type"
                      sx={{
                        ".MuiInput-input": {
                          color: "#1197B2",
                          fontWeight: "500",
                        },
                      }}
                      disabled={Boolean(readOnly)}
                    >
                      {taskTypeList &&
                        taskTypeList["length"] > 0 &&
                        taskTypeList.map((ele, index) => (
                          <MenuItem
                            key={index}
                            value={ele["id"]}
                            selected
                            sx={{
                              color: "#1197B2 !important",
                              fontWeight: "400",
                            }}
                          >
                            {ele["name"]}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
                {selectedTaskTypeID !== TaskTypeEnum.MonitorLiveAgents ? (
                <Grid item xs={6}>
                  <FormControl variant="standard" fullWidth>
                    <Autocomplete
                      id="search-unplugged-patient"
                      open={openUserAutoComplete}
                      onOpen={() => {
                        this.setUserAutoCompleteAction(true);
                      }}
                      onClose={() => {
                        this.setUserAutoCompleteAction(false);
                        this.handleChangeUsers(null, null, "clear");
                      }}
                      getOptionLabel={(option) => option.value}
                      options={userDataList}
                      loading={loading}
                      value={selectedUser}
                      inputValue={selectedUserInputValue}
                      onChange={this.handleChangeUsers}
                      onInputChange={(event, newInputValue) => {
                        this.setState({
                          selectedUserInputValue: newInputValue,
                        });
                      }}
                      disabled={Boolean(readOnly)}
                      sx={{
                        ".MuiAutocomplete-listbox": {
                          color: "#1197B2 !important",
                          fontWeight: "400",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("Task.AssignedToLabel")}
                          variant="standard"
                          onChange={(ev) => {
                            if (
                              ev.target.value !== "" ||
                              ev.target.value !== null
                            ) {
                              this.onUserChange(ev.target.value);
                              this.setState({ isUserRequired: false });
                            }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading && (
                                  <CircularProgress color="inherit" size={20} />
                                )}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                          error={isUserRequired}
                          helperText={
                            isUserRequired &&
                            t("Task.Validate.EnterAssignedTitle")
                          }
                        />
                      )}
                    />
                  </FormControl>
                </Grid>) : (
                  <Grid item xs={6}>
                    <FormControl variant="standard" fullWidth>
                      <TextField
                        id="standard-basic"
                        label={t("Automation.Email")}
                        variant="standard"
                        onChange={(event) => {
                          this.setState({ 
                            selectedEmails: event.target.value, 
                            isTaskEmailRequired: false 
                          });
                        }}
                        placeholder={t("Task.Validate.SelectUsersLabel")}
                        value={selectedEmails}
                        disabled={Boolean(readOnly)}
                        error={isTaskEmailRequired}
                        helperText={
                          isTaskEmailRequired && t("Task.Validate.TaskEmail")
                        }
                      />
                    </FormControl>
                  </Grid>
                ) }
              </Grid>
              {selectedTaskTypeID !== TaskTypeEnum.MonitorLiveAgents ? (
              <Grid container spacing={2} sx={{ mt: "0px" }}>
                <Grid item xs={6}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel id="demo-simple-select-standard-label">
                      {t("Task.StatusLabel")}
                    </InputLabel>
                    <Select
                      labelId="action-simple-select-standard-label"
                      id="action-simple-select-standard"
                      value={status}
                      onChange={(event) =>
                        this.setState({ status: event.target.value })
                      }
                      label={t("Task.StatusLabel")}
                      sx={{
                        ".MuiInput-input": {
                          color: "#1197B2",
                          fontWeight: "500",
                        },
                      }}
                      disabled={Boolean(readOnly)}
                    >
                      {STATUS.map((items, index) => (
                        <MenuItem
                          key={index}
                          value={items}
                          selected
                          sx={{
                            color: "#1197B2 !important",
                            fontWeight: "400",
                          }}
                        >
                          {items}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>                 
                </Grid> 
                <Grid item xs={6}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel id="demo-simple-select-standard-label">
                      {t("Task.PriorityLabel")}
                    </InputLabel>
                    <Select
                      labelId="action-simple-select-standard-label"
                      id="action-simple-select-standard"
                      value={priority}
                      onChange={(event) =>
                        this.setState({ priority: event.target.value })
                      }
                      label={t("Task.PriorityLabel")}
                      sx={{
                        ".MuiInput-input": {
                          color: "#1197B2",
                          fontWeight: "500",
                          ".Mui-disabled": {
                            color: "#1197B2",
                            fontWeight: "500",
                          },
                        },
                      }}
                      disabled={Boolean(readOnly)}
                    >
                      {PRIORITY.map((items, index) => (
                        <MenuItem
                          key={index}
                          value={items}
                          sx={{
                            color: "#1197B2 !important",
                            fontWeight: "400",
                          }}
                        >
                          {items}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>) : (
                <Grid container spacing={2} sx={{ mt: "0px" }}>
                  <Grid item xs={6}>
                    <FormControlLabel
                        label={
                          <span style={{ color: '#000', fontSize: '1rem' }}>
                            {t('Patient.Enabled')}
                          </span>
                        }
                        labelPlacement='start'
                        control={
                            <Switch
                              name='checkConsult'
                              color='primary'
                              checked={this.state.isEanbled}
                              onChange={
                                this.handleSwitchChangeIsEnableTask
                              }
                              disabled={this.state.operation === 'View'}
                              value='checked'
                            />
                        }
                        style={{ marginLeft: '0px', marginTop: '5px' }}
                    />
                  </Grid>
                </Grid>
              )}
              {selectedTaskTypeID !== TaskTypeEnum.MonitorLiveAgents ? (
              <Grid container sx={{ mt: "15px" }}>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <TextField
                      id="standard-basic"
                      label={t("Task.TaskDetailsLabel")}
                      variant="outlined"
                      multiline
                      rows={7}
                      onChange={(event) => {
                        this.setState({
                          taskDetails: event.target.value,
                          isTaskDetailsRequired: false,
                        });
                      }}
                      value={taskDetails}
                      disabled={Boolean(readOnly)}
                      error={isTaskDetailsRequired}
                      helperText={
                        isTaskDetailsRequired &&
                        t("Task.Validate.EnterTaskDetails")
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>) : null }
              {selectedTaskTypeID !== TaskTypeEnum.MonitorLiveAgents ? (
              <Grid container spacing={2} sx={{ mt: "0px" }}>
                <Grid item xs={6}>
                  <FormControl variant="standard" fullWidth>
                    <Autocomplete
                      id="search-unplugged-patient"
                      open={openPatientAutoComplete}
                      onOpen={() => {
                        this.setPatientAutoCompleteAction(true);
                      }}
                      onClose={() => {
                        this.setPatientAutoCompleteAction(false);
                        this.handleChangePatients(null, null, "clear");
                      }}
                      getOptionLabel={(option) => option.name}
                      options={patientDataList}
                      loading={loadingPatient}
                      value={selectedPatient}
                      inputValue={selectedPatientInputValue}
                      onChange={this.handleChangePatients}
                      onInputChange={(event, newInputValue) => {
                        this.setState({
                          selectedPatientInputValue: newInputValue,
                        });
                      }}
                      disabled={Boolean(readOnly)}
                      sx={{
                        ".MuiAutocomplete-listbox": {
                          color: "#1197B2 !important",
                          fontWeight: "400",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={t("Task.PatientLabel")}
                          variant="standard"
                          onChange={(ev) => {
                            if (
                              ev.target.value !== "" ||
                              ev.target.value !== null
                            ) {
                              this.onPatientChange(ev.target.value);
                              this.setState({ isPatientRequired: false });
                            }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loadingPatient && (
                                  <CircularProgress color="inherit" size={20} />
                                )}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                          error={isPatientRequired}
                          helperText={
                            isPatientRequired && t("Task.Validate.EnterPatient")
                          }
                        />
                      )}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl variant="standard" fullWidth>
                    <TextField
                      id="standard-basic"
                      label={t("Task.OrderCode")}
                      variant="standard"
                      onChange={(event) => {
                        this.setState({ orderCode: event.target.value });
                      }}
                      value={orderCode}
                      disabled={Boolean(readOnly)}
                    />
                  </FormControl>
                </Grid>
              </Grid>): null }
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleCloseTaskManagerDialog}
                color="primary"
                className={classes["primaryButton"]}
              >
                {operation === "View" ? t("Task.Close") : t("Task.Cancel")}
              </Button>
              {operation !== "View" && (
                <Button
                  color="primary"
                  className={classes["primaryButton"]}
                  onClick={(event) => {
                    operation === "Add"
                      ? this.handleSubmit(event)
                      : this.handleUpdate(event);
                  }}
                >
                  {operation === "Add" ? t("Task.Save") : t("Task.Update")}
                </Button>
              )}
            </DialogActions>
          </Dialog>
          <Dialog
            maxWidth={"md"}
            fullWidth={true}
            open={openDeleteDialog || false}
            onClose={this.handleCloseDeleteDialog}
            aria-labelledby="form-dialog-title"
            PaperProps={{
              sx: { minWidth: "500px" },
            }}
          >
            {this.renderLoaderIndicator()}
            <BootstrapDialogTitle
              id="customized-dialog-title"
              onDialogClose={this.handleCloseDeleteDialog}
            >
              {t("Task.AreYouSureToDeleteText")}
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <Box component="div">
                {confirmedDeleteList &&
                  confirmedDeleteList.map((ele, index) => (
                    <Box
                      component="div"
                      key={index}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        m: "0.5rem",
                      }}
                    >
                      {" • "} {ele["task_name"]}
                    </Box>
                  ))}
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleCloseDeleteDialog}
                color="primary"
                className={classes["primaryButton"]}
              >
                {t("Task.Cancel")}
              </Button>
              <Button
                color="primary"
                className={classes["primaryButton"]}
                onClick={this.handleConfirmDelete}
              >
                {t("Task.Delete")}
              </Button>
            </DialogActions>
          </Dialog>
          <EnhancedTableToolbar
            TotalRowsSelected={selectedData.length || 0}
            openTaskManagerDialogClick={this.handleOpenTaskManagerDialog}
            DeleteTaskClick={this.handleOpenDeleteDialog}
          />
        </Box>
        <Divider />
        <Box component="div" sx={{ overflowX: "auto" }}>
          <ILocalAGGrid
            columnDefs={this.getColumnDefs()}
            defaultColDef={getDefaultColDef({ minWidth: 100 })}
            rowSelection="multiple"
            rowModelType="serverSide"
            cacheBlockSize={filterObj.pageSize || 10}
            paginationPageSize={filterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={50}
            getRowId={(params) => params.data && String(params.data.id)}
            onGridReady={this.onGridReady}
            onRowSelected={this.onRowSelected}
            onPaginationChanged={this.onPaginationChanged}
            getContextMenuItems={this.getContextMenuItems}
          />
        </Box>
      </Box>
    );
  }
}

export default withStyles(useStyles, { withTheme: true })(
  withTranslation()(TaskManager)
);



// WEBPACK FOOTER //
// ./src/components/taskmanager/index.js